let size;
const config = {
    smallSize: {
        routeMarker: {
            width: 20,
            heigth: 20,
            anchorX: 10,
            anchorY: 10
        },
        routeLine: {
            width: 3
        },
        marker: {
            characters: 9
        },
        popup: {
            minWidth: 350,
            maxHeight: 300
        }
    },
    mediumSize: {
        routeMarker: {
            width: 20,
            heigth: 20,
            anchorX: 10,
            anchorY: 10
        },
        routeLine: {
            width: 4
        },
        marker: {
            characters: 13
        },
        popup: {
            minWidth: 450,
            maxHeight: 400
        }
    }
};

window.addEventListener('resize', function () {
    let { x, y } = calcWindowSize();
    x < 1800 ? size = 'smallSize' : size = 'mediumSize';
}, true);

let { x, y } = calcWindowSize();
x < 1800 ? size = 'smallSize' : size = 'mediumSize';

export function getConfig() {
    return config[size];
};

function calcWindowSize() {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;
    return { x: x, y: y };
}
